import React from "react";
import * as Icon from "react-feather";

/**
 * NMU-608: the built-in icons an editor can pick for a ทางลัดด่วน.
 *
 * Same contract as the intranet icons (constants/intranet-icons): the *key* is
 * what travels to the portal, and nmu-web's `lib/quick-link-icons.tsx` maps the
 * same strings onto its own (lucide) set. Adding a key here without adding it
 * there makes the shortcut fall back to a chain icon, so change both together.
 *
 * react-feather has no anti-corruption or scales glyph; `Slash` over a coin and
 * `Award` are the closest members of the set the rest of the admin already uses,
 * and an editor who wants the real ป.ป.ช. / ป.ป.ท. emblems uploads them instead
 * — the portal prefers an uploaded image over the icon.
 */
export const QUICK_LINK_ICONS = [
  { value: "phone", label: "สายตรง (phone)", icon: Icon.Phone },
  { value: "no-money", label: "ต่อต้านทุจริต (no money)", icon: Icon.Slash },
  { value: "complaint", label: "ร้องเรียน (complaint)", icon: Icon.AlertOctagon },
  { value: "shield", label: "ธรรมาภิบาล / ITA (shield)", icon: Icon.Shield },
  { value: "scale", label: "กฎหมาย (scale)", icon: Icon.Award },
  { value: "landmark", label: "หน่วยงานราชการ (landmark)", icon: Icon.Home },
  { value: "file-text", label: "เอกสาร (file)", icon: Icon.FileText },
  { value: "mail", label: "ติดต่อ (mail)", icon: Icon.Mail },
  { value: "news", label: "ข่าวสาร (news)", icon: Icon.Bookmark },
  { value: "users", label: "บุคลากร (users)", icon: Icon.Users },
  { value: "calendar", label: "ปฏิทิน (calendar)", icon: Icon.Calendar },
  { value: "link", label: "ลิงก์ทั่วไป (link)", icon: Icon.Link2 },
];

/** The colour the portal draws these in — a dark-green badge. */
export const QUICK_LINK_ICON_COLOR = "#1b341a";

const BY_VALUE = QUICK_LINK_ICONS.reduce((acc, opt) => {
  acc[opt.value] = opt;
  return acc;
}, {});

/**
 * The glyph for a stored key, for the list column.
 *
 * An unknown key draws the chain icon rather than nothing, which is what the
 * portal does with it too — a blank cell would read as "no icon set" when the
 * record does have one the two sides disagree about.
 */
export const QuickLinkIcon = ({ value, size = 20 }) => {
  const opt = BY_VALUE[value];
  const Glyph = opt ? opt.icon : Icon.Link2;
  return <Glyph size={size} color={QUICK_LINK_ICON_COLOR} />;
};
